// @flow

import React from 'react';
import ConfigChoiceComponent from './configChoice';
import type { ACFProps } from './types';

const ConfigChoice = ({
  title,
  description,
  acf_fc_layout,
  error_text,
}: ACFProps) => (
  <ConfigChoiceComponent
    title={title}
    description={description}
    type={acf_fc_layout}
    errorText={error_text}
  />
);

export default ConfigChoice;
